import React from 'react';
import { Link } from 'react-router-dom';
export function FreeTrialRelatedLinks() {
  return <section className="py-12 bg-subtle-gray/30 border-t border-subtle-gray" data-id="element-1565">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1566">
        <p className="text-sm font-bold text-gray-warm uppercase tracking-wide mb-6" data-id="element-1567">
          Explore More Classes & Programs
        </p>
        <div className="flex flex-wrap justify-center gap-4 md:gap-8" data-id="element-1568">
          <Link to="/Programs.html" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-1569">
            Programs Overview
          </Link>
          <Link to="/karate-kids-classes.html" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-1570">
            Kids Classes
          </Link>
          <Link to="/karate-adult-classes" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-1571">
            Adult Classes
          </Link>
          <Link to="/FamilyKarateClasses.html" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-1572">
            Family Classes
          </Link>
          <Link to="/summer-camp" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-1573">
            Summer Camp
          </Link>
          <Link to="/ContactUs.html" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-1574">
            Contact
          </Link>
        </div>
      </div>
    </section>;
}